import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { DocumentPlusIcon } from '@heroicons/react/16/solid';
import { Fragment } from 'react/jsx-runtime'
import { Footer } from '../components/footer'
import { Heading } from '../components/heading'
import { useNavigate } from 'react-router-dom';
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { PageInfo } from '../components/page-info'
const breadcrumbs_link = [
  { name: "Add New Company", href: "#", current: true }  
];
const page_info = `Here you can choose method to add your company, either using GMC or Direct GB Feed`; 



export default function AddNewCompany () {
  const navigate = useNavigate();  
  
  const handleRadioClick = (e) => {	    
    if (e.target.value === 'gmc') {
      navigate('/add-new-company-gmc');
    } else if (e.target.value === 'gb_feed') {
      navigate('/add-new-company-gb');
    }
  };
  
  return (
  	<Fragment>
    	<SidebarLayoutNew selected_menu="addnewcompany">
		<BreadcrumbsNew pages={breadcrumbs_link} />
		<div className="flex w-full items-center gap-3 rounded-lg !pl-0 px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">      
      		<DocumentPlusIcon className="!size-8"/>
	  		<Heading>Add New Company</Heading>
		</div>
    	<PageInfo info={page_info} />
    	<div className="min-w-full">
			
			<div className="flex gap-8 mt-8 ml-8">
			  <label className="text-lg flex items-center gap-2">
				Link From GMC
				<input type="radio" name="add_new_company" value="gmc" onChange={handleRadioClick} className="w-6 h-6" />
			  </label>
			  
			  <label className="text-lg flex items-center gap-2">
				Link From GB Feed
				<input type="radio" name="add_new_company" value="gb_feed" onChange={handleRadioClick} className="w-6 h-6" />
			  </label>
			</div>
	  
    	</div>	
		</SidebarLayoutNew>
    	<Footer />
    </Fragment>
  );
}